import { render, staticRenderFns } from "./StwPower.vue?vue&type=template&id=27b3b954&scoped=true&"
import script from "./StwPower.vue?vue&type=script&lang=js&"
export * from "./StwPower.vue?vue&type=script&lang=js&"
import style0 from "./StwPower.vue?vue&type=style&index=0&id=27b3b954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3b954",
  null
  
)

export default component.exports